<template>
    <span>
      <b-card no-body>
        <b-card-header>
          <b-row>
            <b-col md="7" lg="9">
              <h3 tabindex="0">Listar Caderno de Propostas</h3>
            </b-col>
            <b-col sm="4" md="5" lg="3">
              <b-button @click="navigate('/proposta/cadastrar')" block variant="primary">
                    <i class="fa fa-plus"></i>
                  <span>Novo Cadastro</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group label="Título">
                <b-form-input type="text" id="name" v-model="filtros.filter" placeholder="Título"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group label="Situação:">
                    <b-form-select v-model="filtros.situacao" placeholder="Situação" class="mb-3">
                          <option selected :value="null">Selecione</option>
                          <option v-for="item in situacoes" :key="item.id" :value="item.value"> {{item.text}}</option>
                    </b-form-select>
                </b-form-group>
              </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="4" lg="3">
              <b-button block variant="primary" @click="pesquisar">
                <i class="fa fa-search"></i>&nbsp;&nbsp;<span>Pesquisar</span>
              </b-button>
            </b-col>  
            <b-col v-if="!loading" sm="12" md="4" lg="3">
            <b-button block variant="primary" @click="exportar">
              <i class="fa fa-file"></i>&nbsp;&nbsp;<span>Exportar</span>
            </b-button>
          </b-col>
          <b-col v-if="loading" sm="12" md="4" lg="3">
            <b-button block variant="primary" :disabled="true">
              <b-spinner small type="grow"></b-spinner>Exportando...</b-button>
          </b-col>
         </b-row>
        </b-card-body>
        <b-row>
          <b-col sm="12">
            <b-container fluid>
              <span>
                <b-col class="table-responsive">
                  <table selectable aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-bordered table-striped table-sm">
                    <thead>
                      <tr>
                        <th scope="col" tabindex="0">Título</th>
                        <th scope="col" tabindex="0">Status</th>
                        <th scope="col" tabindex="0">Visibilidade após encerramento</th>
                        <th scope="col" tabindex="0">Permitir Contribuição</th>
                        <th scope="col" tabindex="0">Período</th>
                        <th scope="col" tabindex="0">Ações</th>
                      </tr>
                    </thead>

                    <tbody v-if="propostas.data !== undefined">
                      <tr class="action" v-for="proposta in propostas.data" :key="proposta.id">
                        <td tabindex="0">{{proposta.titulo}}</td>
                        <td>
                          <b-button tabindex="0" size="sm" v-if="proposta.situacao === 'C'" @click="enviarProposta(proposta.id, proposta.situacao)" pill variant="primary">Salvo</b-button>
                          <b-button tabindex="0" size="sm" v-if="proposta.situacao === 'E'" @click="suspenderProposta(proposta.id, proposta.situacao)" pill variant="success">Enviado</b-button>
                          <b-button tabindex="0" size="sm" v-if="proposta.situacao === 'S'" @click="salvarProposta(proposta.id, proposta.situacao)" pill variant="danger">Suspenso</b-button>                       
                        </td>
                        <td>
                          <b-button tabindex="0" size="sm" v-if="proposta.visivel_encerrado" @click="desativaVisibilidade(proposta.id)" pill variant="success">Visível</b-button>
                          <b-button tabindex="0" size="sm" v-if="!proposta.visivel_encerrado" @click="ativaVisibilidade(proposta.id)" pill variant="danger">Não Visível</b-button> 
                        </td>
                        <td>
                          <b-button tabindex="0" size="sm" v-if="proposta.permite_contribuicao" @click="desativaContribuicao(proposta.id)" pill variant="success">Habilitado</b-button>
                          <b-button tabindex="0" size="sm" v-if="!proposta.permite_contribuicao" @click="chamaModalContribuicao(proposta.id)" pill variant="danger">Desabilitado</b-button> 
                        </td>
                        <td>
                          <span v-if="proposta.data_contribuicao_inicio && proposta.data_contribuicao_fim"> {{ moment(proposta.data_contribuicao_inicio).format('DD/MM/YYYY HH:mm') }} a {{ moment(proposta.data_contribuicao_fim).format('DD/MM/YYYY HH:mm') }}</span>
                          <span v-else> - </span>
                        </td>
                        <td style="width: 15%">
                            <b-button v-if="proposta.situacao === 'C' || proposta.situacao === 'S'"  tabindex="0" class="btn btn-sm btn-secondary action" title="Editar" @click="editarProposta(proposta.id)">
                              <i class="fa fa-pencil-square-o"></i>
                            </b-button>

                            <b-button class="btn btn-sm btn-secondary action" title="Visualizar" tabindex="0"  @click="visualizarProposta(proposta.id)">
                              <i class="fa fa-search"></i>
                            </b-button>

                            <!-- <a v-if="proposta.situacao === 'C' || proposta.situacao === 'S'" class="btn btn-sm btn-secondary action" title="Enviar Caderno" @click="enviarProposta(proposta.id)">
                              <i class="fa fa-envelope"></i>
                            </a> -->
                            
                            <b-button class="btn btn-sm btn-secondary action" tabindex="0" title="Remover Proposta" @click="excluirProposta(proposta.id)">
                              <i class="fa fa-trash"></i>
                            </b-button>

                              <b-dropdown id="dropdown-1" size="sm" class="m-1" no-flip>
                                <template v-slot:button-content>
                                  <i class="fa fa-file"></i>
                                </template>

                                <b-dropdown-item                                  
                                  @click="exportarPropostaEtapa1(proposta.id)"
                                >Exportar Sugestões de Edição
                                </b-dropdown-item>

                                <b-dropdown-item                                 
                                  @click="exportarPropostaEtapa2(proposta.id)"
                                >Exportar Votação
                                </b-dropdown-item>

                                <b-dropdown-item                                 
                                  @click="exportarPropostaEtapa3(proposta.id)"
                                >Exportar Priorização
                                </b-dropdown-item>  
                              </b-dropdown>                   
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr class="action">
                        <td colspan="6" tabindex="0">Nenhum caderno de propostas cadastrado</td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
                <!-- <pagination tabindex="0" v-show="propostas.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource"></pagination> -->
              </span>
            </b-container>
          </b-col>
        </b-row>
      </b-card>
      <b-modal title="Período de Contribuição" :hide-footer="true" size="lg" v-model="modalPeriodoContribuicao">
      <b-card-body>
        <b-form>
          <b-row>
              <b-col cols="4">
                  <b-form-group label="Data e hora de Início">
                      <b-input-group>                         
                          <b-form-input id="type-date" type="datetime-local" min="2000-01-01T00:00" max="2200-12-01T00:00"
                              v-model.lazy.trim="modal_periodo.data_contribuicao_inicio"></b-form-input>
                      </b-input-group>
                  </b-form-group>
              </b-col>
              <div><strong>a</strong></div>
              <b-col cols="4">
                  <b-form-group label="Data e hora de Fim">
                      <b-input-group>                      
                          <b-form-input id="type-date" type="datetime-local" min="2000-01-01T00:00" max="2200-12-01T00:00"
                              v-model.lazy.trim="modal_periodo.data_contribuicao_fim"></b-form-input>
                      </b-input-group>
                  </b-form-group>
              </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="8">
          </b-col>
          <b-col md="2">
            <b-button block variant="secondary" @click="fecharModal()">
              <span>Cancelar</span>
            </b-button>
          </b-col>
          <b-col md="2">
            <b-button block variant="primary" @click="ativaContribuicao()">
              <span>Salvar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-modal>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import {DatePicker, setupCalendar} from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import moment from 'moment'

setupCalendar({
  firstDayOfWeek: 2 // Monday
})

miniToastr.init()

export default {
  components: {
    Pagination,
    'v-date-picker': DatePicker,
    Multiselect
  },
  created () {
    if (!this.validaPerfil()) {
       this.$router.push('/')
    }

    this.pesquisar()
  },
  data () {
    return {
      totalPorPagina: false,
      loading: false,
      resource: 'proposta',
      filtros: {
        filter: null,
        situacao: null
      },
      modal_periodo: {
        id: null,
        data_contribuicao_inicio: null,
        data_contribuicao_fim: null
      },
      situacoes: [
        { value: 'C', text: 'Salvo' },
        { value: 'E', text: 'Enviado' },
        { value: 'S', text: 'Suspenso' }
      ],
      modalPeriodoContribuicao: false,
    }
  },
  computed: {
    propostas () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    inputState () {
      if (!this.selectedValue) {
        return {
          type: 'is-danger',
          message: 'Data do cadastro'
        }
      }
      return {
        type: 'is-primary',
        message: ''
      }
    }
  },
  methods: {
    validaPerfil () {
       let perfil = this.$store.state.perfil.perfil     
       if (perfil.is_admin_conferencia) {
         return true
       }
       return false
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    editarProposta (id) {
      this.$router.push('/proposta/editar/' + id)
    },
    visualizarProposta (id) {
      this.$router.push('/proposta/' + id)
    },
    pesquisar () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
      this.setarFiltros(this.filtros)
    },
    enviarProposta (id) {
      this.$bvModal.msgBoxConfirm('Deseja enviar o caderno de proposta?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/proposta/' + id + '/enviado').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina})
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina})
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    desativaVisibilidade (id){
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja desativar visiblidade após encerramento?', {
              okTitle: 'Confirmar',
              cancelTitle: 'Cancelar'
        }).then(valor => {
          if (valor) { 
            Vue.http.put('api/proposta/'+ id +'/desativar_visibilidade').then(response => {
              if (response.body.success) {
                miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
                miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina})
              } else {
                miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
                miniToastr.error(response.body.msg, 'Alerta', 5000)
              } this.loading = false
                }).catch(e => {
             })
          }
        }).catch(erro => {
          console.log(erro)
      })
    },
    ativaVisibilidade (id){
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja ativar visiblidade após encerramento?', {
              okTitle: 'Confirmar',
              cancelTitle: 'Cancelar'
        }).then(valor => {
          if (valor) { 
            Vue.http.put('api/proposta/'+ id +'/ativar_visibilidade').then(response => {
              if (response.body.success) {
                miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
                miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina})
              } else {
                miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
                miniToastr.error(response.body.msg, 'Alerta', 5000)
              } this.loading = false
                }).catch(e => {
             })
          }
        }).catch(erro => {
          console.log(erro)
      })
    },
    desativaContribuicao (id){
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja desativar a contribuição?', {
              okTitle: 'Confirmar',
              cancelTitle: 'Cancelar'
        }).then(valor => {
          if (valor) { 
            Vue.http.put('api/proposta/'+ id +'/desativar_contribuicao').then(response => {
              if (response.body.success) {
                miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
                miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina})
              } else {
                miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
                miniToastr.error(response.body.msg, 'Alerta', 5000)
              } this.loading = false
                }).catch(e => {
             })
          }
        }).catch(erro => {
          console.log(erro)
      })
    },
    ativaContribuicao (){

      if(!this.modal_periodo.data_contribuicao_inicio){
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Data e hora de início são obrigatórios!', 'Alerta', 5000)
        return false
      }

      if(!this.modal_periodo.data_contribuicao_fim){
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Data e hora finais são obrigatórias!', 'Alerta', 5000)
        return false
      }

      if(moment(this.modal_periodo.data_contribuicao_inicio).isAfter(this.modal_periodo.data_contribuicao_fim)){
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Data e hora de início não podem ser maiores que a data e hora finais!', 'Alerta', 5000)
        return false
      }
      
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja ativar a contribuição?', {
              okTitle: 'Confirmar',
              cancelTitle: 'Cancelar'
        }).then(valor => {
          if (valor) { 
            Vue.http.put('api/proposta/'+ this.modal_periodo.id +'/ativar_contribuicao', this.modal_periodo).then(response => {
              if (response.body.success) {
                miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
                miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina})
                this.modalPeriodoContribuicao = false
              } else {
                miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
                miniToastr.error(response.body.msg, 'Alerta', 5000)
              } this.loading = false
                }).catch(e => {
             })
          }
        }).catch(erro => {
          console.log(erro)
      })
    },
    chamaModalContribuicao(id){
      this.modalPeriodoContribuicao = true
      this.modal_periodo.id = id
      this.modal_periodo.data_contribuicao_inicio = null
      this.modal_periodo.data_contribuicao_fim = null
    },
    salvarProposta (id){
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja alterar a situação?', {
              okTitle: 'Confirmar',
              cancelTitle: 'Cancelar'
        }).then(valor => {
          if (valor) { 
            Vue.http.put('api/proposta/'+ id +'/salvar').then(response => {
              if (response.body.success) {
                miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
                miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina})
              } else {
                miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
                miniToastr.error(response.body.msg, 'Alerta', 5000)
              } this.loading = false
                }).catch(e => {
             })
          }
        }).catch(erro => {
          console.log(erro)
      })
    },
    excluirProposta (id) {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.delete('api/proposta/' + id, {}).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }

            this.loading = false
          }).catch(e => {
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    suspenderProposta (id) {
      this.$bvModal.msgBoxConfirm('Deseja suspender a visualização da proposta?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/proposta/' + id + '/suspenso').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina})
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina})
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    exportar() {
      this.loading = true
      const d = new Date();

      Vue.http.post('api/proposta/exportar', { filtros: this.filtros }, { responseType: 'blob' }).then(response => {
        if (response.ok) {         
          let blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)

          let time = d.getTime();
          link.download = 'CadernosProposta' + time + '.xlsx'
          link.click()
        }
        this.loading = false
      })
    },
    fecharModal(){
      this.modalPeriodoContribuicao = false
    },
    exportarPropostaEtapa1 (proposta) {
      window.location.href = process.env.ROOT_API1 + 'api/proposta/' + proposta + '/documento'
    },
    exportarPropostaEtapa2 (proposta) {
      window.location.href = process.env.ROOT_API1 + 'api/propostasegunda/' + proposta + '/documento'
    },
    exportarPropostaEtapa3 (proposta) {
      window.location.href = process.env.ROOT_API1 + 'api/propostaterceira/' + proposta + '/documento'
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect.invalid .multiselect__tags,
    .multiselect.invalid .multiselect__tags span,
    .multiselect.invalid .multiselect__tags input {
        background:red;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/caderno/Proposta.vue